export default function MilitaryCredibility() {
  return null;
}
